import { call, put } from 'redux-saga/effects';
import { ExportToCsvRequestAction } from '../types';
import { exportToCsvRequest } from '../api';
import { saveAs } from 'file-saver';
import { MessageData } from 'store/app/types';
import { turnMessageOn } from 'store/app/actions';
import { MessageStates } from 'containers/MessageBox';
import { renderErrorMessage } from 'utils/render-error-message';
import { logoutRequest } from 'store/auth/actions';
import { exportToCSVDone } from '../actions';

export function* exportToCsvRequestSaga(action: ExportToCsvRequestAction) {
  const { reportId, transactionType, groupingType } = action.payload;

  try {
    const response = yield call(
      exportToCsvRequest,
      reportId,
      transactionType,
      groupingType
    );

    if (response) {
      const disposition = response.headers.get('Content-Disposition');
      let filename = 'download.csv';
      if (disposition && disposition.includes('attachment')) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches?.[1]) {
          filename = matches[1].replace(/['"]/g, '');
        }
      }

      const blob = yield call([response, 'blob']);
      saveAs(blob, filename);
    }
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
  }

  yield put(exportToCSVDone());
}
